import {
    Button,
    GenericSuspense,
    IconButton,
    List,
    useListFilterState,
    useRuntimeEnv,
    useRuntimeEnvRolesIncludes,
    useTranslations,
    useUrlParamsValueToString,
} from "@bsm/component";
import { TTimeOff } from "@bsm/graphql";
import { Link, Outlet } from "react-router-dom";
import { useMemo, useState } from "react";
import { useDayOffListSort } from "../../../hooks/useDayOffListSort";
import _ from "lodash";
import { MissingListItem } from "../components/MissingListItem";
import { MissingListQuery } from "views/dayoff/queries/MissingListQuery";
import { DayOffMissingListQuickFilter } from "../components/DayOffMissingListQuickFilter";
import DayOffMissingListFilter from "../components/DayOffMissingListFilter";

const ProjectDayOffMissingContainer = () => {
    const [ ADD ] = useTranslations(i18n);

    const sortItems = useDayOffListSort()
    const [openFilter, setOpenFilter] = useState(false)
    const { setFilter } = useListFilterState(MISSING_DAYOFF_LIST_ID);
    const { runtimeEnv } = useRuntimeEnv();
    const userDepartmentId = (runtimeEnv?.user as any)?.department?.id;

    const resetFilter = () => {
        setFilter((v: any) => ({
            ...v,
            data: {
                ...v.data,
                employee: {
                    department: { id: userDepartmentId ?? -1 }
                }
            }
        }))
    }

    return (
        <>
            <div className="space-y-5">
                {/* <div className="flex items-center justify-end">
                    {canAdd && (
                        <div className="flex justify-end">
                            <Link to={`create/missing?${urlParamsToString}`}>
                                <Button
                                    className="btn btn-primary"
                                    startIcon="fa-solid fa-plus"
                                    label={ADD}
                                />
                            </Link>
                        </div>
                    )}
                </div> */}

                <div className="flex gap-4 items-center justify-end">
                    <DayOffMissingListQuickFilter listId={MISSING_DAYOFF_LIST_ID} />
                    <IconButton
                        icon="fa fa-filter-circle-xmark"
                        onClick={resetFilter}
                    />
                    <IconButton
                        icon="fa fa-filter"
                        className="text-primary"
                        onClick={() => setOpenFilter(!openFilter)}
                    />
                </div>

                <List
                    id={MISSING_DAYOFF_LIST_ID}
                    BoxProps={{
                        className: "box-transparent shadow-none",
                    }}
                    selection={false}
                    sort={{ items: sortItems }}
                    pagination={true}
                    GQLRequest={MissingListQuery}
                    defaultFilter={{
                        pageSize: 50,
                        page: 0,
                        sort: [{ sort: 'DESC', value: 'createdAt' }],
                        data: {
                            employee: {
                                department: {
                                    id: userDepartmentId ?? -1
                                }
                            }
                        }
                    }}
                    onRenderRow={(row: TTimeOff) => (
                        <MissingListItem {...row} />
                    )}
                    // onEnableRequest={(params) =>
                    //     params?.instance?.variables?.sort !== undefined
                    // }
                />
            </div>

            <GenericSuspense>
                <Outlet />
            </GenericSuspense>

            <DayOffMissingListFilter open={openFilter} onClose={() => setOpenFilter(false)} />
        </>
    );
};

export default ProjectDayOffMissingContainer;

export const MISSING_DAYOFF_LIST_ID = "dayoff-missing-list-id";
const i18n = [
    "std_add",
    "Harea.Project.DayOff.Create.MissingContract.Message",
    "Harea.project.DayOff.LeaveBalance.Label",
];
